import Axios from 'axios'
import { MIME_TYPES_TO_FILE_EXTENSION, DOC_FLOW_STATUS } from '@/constant/constant'
import { getStorage } from '@/utils/storageUtil'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.ALI + '/ext/ws/docflow/'
const intWsAdminBaseUrl = config.apiDomain.INT + '/int/wsadmin/docflow/'

const getAllDocTypeUrl = baseUrl + 'getAllDfDocType'
const insertFirstDocUrl = baseUrl + 'insertFirstInternalDoc'
const uploadFileUrl = baseUrl + 'uploadDFDocument'
const getProcessListUrl = baseUrl + 'getDfProcessListByMe?pageNo=' // extWsBaseUrl
const forwardProcessUrl = baseUrl + 'finishProcess'
const closeProcessUrl = baseUrl + 'closeProcess?processId='
const getForwardToStaffsUrl = baseUrl + 'getParentProcessForwardInfo?processId='
const downloadDocumentUrl = baseUrl + 'downloadDFDocument'
const downloadDFDocumentByInflowIdUrl = intWsAdminBaseUrl + 'search/downloadDFDocumentByInflowId'
const getProcessAttachmentListUrl = baseUrl + 'getProcessAttachmentList?processId='
const getProcessPrefillInfoUrl = baseUrl + 'getProcessPrefillInfo?processId='
const getAncestorProcessUrl = baseUrl + 'getAncestorProcess?processId='
const getDfProcessListItemDetailUrl = baseUrl + 'getDfProcessListItemDetail?processId='
const getProcessLeafUrl = baseUrl + 'getProcessLeaf?processId='
const getParentProcessForwardInfoUrl = baseUrl + 'getParentProcessForwardInfo?processId='
const getDocumentAttachmentListUrl = baseUrl + 'getDocumentAttachmentList?processId='
const searchUrl = intWsAdminBaseUrl + 'search/fieldSearch?pageNo='
// const getCompletedInflowUrl = baseUrl + 'getCompletedInflowByMe?pageNo='
// const getCompletedProcessUrl = baseUrl + ' getCompletedProcessByMe?dfInflowId='

const getDfProcessListByInflowIdUrl = baseUrl + 'getDfProcessListByInflowId?inflowId='
const markConfirmReceivedProcessUrl = baseUrl + 'markConfirmReceivedProcess?processIds='
const redirectProcessUrl = baseUrl + 'redirectProcess' // Change the statusCode to R = Redirect
const getProcessListByGroupUrl = baseUrl + 'getDfProcessListByGroup?pageNo='
const getProcessListByFollowUrl = baseUrl + 'getDfProcessListByFollow?pageNo='
const getProcessReceiverInfoUrl = baseUrl + 'getDfProcessReceiverInfo?processId='
const getArchiveDocTypeUrl = baseUrl + 'archive/getAllDfArchiveDocType'
const getDfInflowUrl = baseUrl + 'getDfInflow?inflowId='
const getAllDfProcessArchiveDocumentsByInflowIdUrl = baseUrl + 'archive/getAllDfProcessArchiveDocumentsByInflowId?inflowId='
const insertProcessArchiveUrl = baseUrl + 'archive/insertDfProcessArchive'
const insertProcessArchiveDocUrl = baseUrl + 'archive/insertDfProcessArchiveDocument'
const getProcessArchiveDocumentUrl = baseUrl + 'archive/getDfProcessArchiveDocument?processId='
const deleteProcessArchiveDocumentUrl = baseUrl + 'archive/deleteDfProcessArchiveDocument?processId='
const getDfDocumentListByInflowIdUrl = intWsAdminBaseUrl + 'search/getDfDocumentListByInflowId?inflowId='
const genInstructionPdfAndBuildIdLinkUrl = baseUrl + 'pdf/genDocFlowPdfAndBuildIdentificationLink'
const genFlowPdfAndBuildIdLinkUrl = baseUrl + 'pdf/downloadDocFlowProcessesPdf'
const getEdocAssignUnit = baseUrl + 'getEdocAssignUnit?inflowId='
const downloadInstructionPdfUrl = baseUrl + 'pdf/downloadDocFlowPdf' // download the instruction pdf without user's signature
const downloadArchiveDocumentUrl = baseUrl + 'archive/downloadDfProcessArchiveDocument?processId='
const getDfProcessListByInflowIdAndSearchingTypeUrl = intWsAdminBaseUrl + 'search/getDfProcessListByInflowIdAndSearchingType?inflowId='
const getSearchAncestorProcessUrl = intWsAdminBaseUrl + 'search/getAncestorProcess?inflowStatusCodes='
const getDfProcessReceiverInfoUrl = intWsAdminBaseUrl + 'search/getDfProcessReceiverInfo?processId='
const getSearchProcessLeafUrl = intWsAdminBaseUrl + 'search/getProcessLeaf?processId='
const searchInsertDfProcessArchiveDocumentUrl = intWsAdminBaseUrl + 'search/insertDfProcessArchiveDocument'
const downloadDfProcessArchiveDocumentUrl = intWsAdminBaseUrl + 'search/downloadDfProcessArchiveDocument'
const deleteDfProcessArchiveDocumentUrl = intWsAdminBaseUrl + 'search/deleteDfProcessArchiveDocument'
const getProcessReceiverDetailInfoUrl = baseUrl + 'getDfProcessReceiverDetailInfo?processId='
const revokeProcessUrl = baseUrl + 'realDeleteProcess?processId=' // delete process (confirm receive time is null only)
const downloadInstructionSignedPdfUrl = baseUrl + 'pdf/downloadDocFlowPdfByDocCode?processId=' // download the signed instruction pdf
const downloadDocumentByDocCodeUrl = baseUrl + 'downloadDocumentByDocCode?docCode=' // Download the document by document code, for uploader only
const getProcessAttachmentCreateInfoUrl = baseUrl + 'getProcessAttachmentCreateInfo?processId='
const getManageableSubunitsUrl = intWsAdminBaseUrl + 'search/getManageableSubunits'
const getChildProcessArchiveDocUrl = baseUrl + 'archive/getChildDfProcessArchiveDocument?processId=' // get child and itself's archived document
const downloadBatchDocumentUrl = baseUrl + 'downloadBatchDFDocument?processId=' // download multi files as a zipped file
const getDFDocumentKeyUrl = intWsAdminBaseUrl + 'search/getDFDocumentKey'
const documentOpenerKeyUrl = intWsAdminBaseUrl + 'search/dfDocumentOpenerKey'
const getMcProcessReceiverInfoUrl = baseUrl + 'getMcProcessReceiverInfo?processId=' // getMcProcessReceiverInfo --- Used by MC only, will return the whole tree

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

export default {
  uploadFileUrl,
  downloadDocumentUrl,
  genInstructionPdfAndBuildIdLinkUrl,
  downloadDFDocumentByInflowIdUrl,

  getAllDocType (cb) {
    Axios.get(getAllDocTypeUrl).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getProcessList (pageNo, pageSize, status, inflowStatus, keyword, dfType, isContainPrefilledInsOnly, orderByKey, isContainPrefilledReceiverOnly, cb) {
    let statusCodes = ''
    for (let i = 0; i < status.length; i++) {
      statusCodes += '&statusCodes=' + status[i]
    }
    let inflowStatusCodes = ''
    for (let i = 0; i < inflowStatus.length; i++) {
      inflowStatusCodes += '&inflowStatusCodes=' + inflowStatus[i]
    }
    let url = ''
    url = getProcessListUrl + pageNo + '&pageSize=' + pageSize + statusCodes + inflowStatusCodes + '&dfType=' + dfType + '&isContainPrefilledInsOnly=' + isContainPrefilledInsOnly
    if (orderByKey !== null) {
      url += '&orderByKey=' + orderByKey
    }
    if (keyword) {
      url += '&keyword=' + keyword
    }
    if (isContainPrefilledReceiverOnly) {
      url += '&isContainPrefilledReceiverOnly=' + isContainPrefilledReceiverOnly
    }
    if (!status.includes(DOC_FLOW_STATUS.WAITING)) {
      url += '&showMonth=3'
    }
    return new Promise((resolve, reject) => {
      Axios.get(url).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        })
    })
  },

  insertFirstDoc (data, cb) {
    Axios.post(insertFirstDocUrl, data).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  forwardProcess (data, cb) {
    Axios.post(forwardProcessUrl, data).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  closeProcess (processId, cb, oriStatusCode) {
    let tempUrl = closeProcessUrl + processId
    if (oriStatusCode) {
      tempUrl += '&oriStatusCode=' + oriStatusCode
    }
    Axios.post(tempUrl).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  closeProcessWithSenderInstruction (cb, processId, isApprover, closedSenderInstruction, oriStatusCode) {
    let tempUrl = baseUrl + 'closeProcessWithSenderInstruction?processId=' + processId + '&isApprover=' + isApprover + '&closedSenderInstruction=' + closedSenderInstruction
    if (oriStatusCode) {
      tempUrl += '&oriStatusCode=' + oriStatusCode
    }
    Axios.post(tempUrl).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  cancelProcess (cb, processId, cancelReason, oriStatusCode) {
    let statusQuery = ''
    if (oriStatusCode) {
      statusQuery = '&oriStatusCode=' + oriStatusCode
    }
    Axios.post(baseUrl + 'cancelProcess?processId=' + processId + '&cancelReason=' + cancelReason + statusQuery).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getForwardToStaffs (processId, cb) {
    Axios.get(getForwardToStaffsUrl + processId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getProcessAttachmentList (processId, cb) {
    Axios.get(getProcessAttachmentListUrl + processId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getProcessPrefillInfo (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getProcessPrefillInfoUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error)
        }
      )
    })
  },

  getAncestorProcess  (processId, inflowStatus, cb) {
    Axios.defaults.headers['Accept-Language'] = getStorage('g2e-lang')
    let inflowStatusCodes = ''
    for (let i = 0; i < inflowStatus.length; i++) {
      inflowStatusCodes += '&inflowStatusCodes=' + inflowStatus[i]
    }
    return new Promise((resolve, reject) => {
      Axios.get(getAncestorProcessUrl + processId + inflowStatusCodes).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error)
        }
      )
    })
  },

  getDfProcessListItemDetail (cb, processId) {
    return new Promise((resolve, reject) => {
      Axios.get(getDfProcessListItemDetailUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error)
        }
      )
    })
  },

  getProcessLeaf  (processId, cb) {
    Axios.defaults.headers['Accept-Language'] = getStorage('g2e-lang')
    return new Promise((resolve, reject) => {
      Axios.get(getProcessLeafUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error)
        }
      )
    })
  },

  getParentProcessForwardInfo (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getParentProcessForwardInfoUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error)
        }
      )
    })
  },

  getDocumentAttachmentList (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getDocumentAttachmentListUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error)
        }
      )
    })
  },

  getInstructionPdf (cb, processId, inflowStatus) {
    // let inflowStatusCodes = ''
    // for (let i = 0; i < inflowStatus.length; i++) {
    //   inflowStatusCodes += '&inflowStatusCodes=' + inflowStatus[i]
    // }
    let body = {
      inflowStatusCodes: inflowStatus,
      processId: processId
    }
    Axios.post(downloadInstructionPdfUrl, body, { responseType: 'blob' }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  search (pageNo, pageSize, form, searchingType, cb) {
    let param = searchUrl + pageNo + '&recNo=' + pageSize // + '&searchingType=' + searchingType
    console.log('search : ' + param)
    Axios.post(param, form).then(
      response => {
        // console.log('search : ' + JSON.stringify(response.data))
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDfProcessListByInflowId (inflowId, cb) {
    Axios.get(getDfProcessListByInflowIdUrl + inflowId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getProcessArchiveDocument (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getProcessArchiveDocumentUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error.resolve)
        }
      )
    })
  },

  markConfirmReceivedProcess (processId, cb) {
    Axios.post(markConfirmReceivedProcessUrl + processId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  redirectProcess (form, cb) {
    return new Promise((resolve, reject) => {
      Axios.post(redirectProcessUrl, form).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  getProcessListByGroup (pageNo, pageSize, status, inflowStatus, keyword, gid, dfType, isContainPrefilledInsOnly, orderByKey, isContainPrefilledReceiverOnly, cb) {
    let statusCodes = ''
    for (let i = 0; i < status.length; i++) {
      statusCodes += '&statusCodes=' + status[i]
    }
    let inflowStatusCodes = ''
    for (let i = 0; i < inflowStatus.length; i++) {
      inflowStatusCodes += '&inflowStatusCodes=' + inflowStatus[i]
    }
    let url = ''
    url = getProcessListByGroupUrl + pageNo + '&pageSize=' + pageSize + statusCodes + inflowStatusCodes + '&gid=' + gid + '&dfType=' + dfType + '&isContainPrefilledInsOnly=' + isContainPrefilledInsOnly
    if (orderByKey !== null) {
      url += '&orderByKey=' + orderByKey
    }
    if (keyword) {
      url += '&keyword=' + keyword
    }
    if (isContainPrefilledReceiverOnly) {
      url += '&isContainPrefilledReceiverOnly=' + isContainPrefilledReceiverOnly
    }
    if (!status.includes(DOC_FLOW_STATUS.WAITING)) {
      url += '&showMonth=3'
    }
    return new Promise((resolve, reject) => {
      Axios.get(url).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        })
    })
  },

  getProcessListByFollow (pageNo, pageSize, status, inflowStatus, keyword, followedEuid, dfType, isContainPrefilledInsOnly, orderByKey, cb) {
    let statusCodes = ''
    for (let i = 0; i < status.length; i++) {
      statusCodes += '&statusCodes=' + status[i]
    }
    let inflowStatusCodes = ''
    for (let i = 0; i < inflowStatus.length; i++) {
      inflowStatusCodes += '&inflowStatusCodes=' + inflowStatus[i]
    }
    let url = ''
    url = getProcessListByFollowUrl + pageNo + '&pageSize=' + pageSize + statusCodes + inflowStatusCodes + '&followedEuid=' + followedEuid + '&dfType=' + dfType + '&isContainPrefilledInsOnly=' + isContainPrefilledInsOnly
    if (orderByKey !== null) {
      url += '&orderByKey=' + orderByKey
    }
    if (keyword) {
      url += '&keyword=' + keyword
    }
    if (!status.includes(DOC_FLOW_STATUS.WAITING)) {
      url += '&showMonth=3'
    }
    return new Promise((resolve, reject) => {
      Axios.get(url).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        })
    })
  },

  postProcessToEDoc (cb, body) {
    return new Promise((resolve, reject) => {
      Axios.post(baseUrl + 'postProcessToEDoc', body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        })
    })
  },

  getProcessReceiverInfo (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getProcessReceiverInfoUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  getDfInflow (inflowId, cb) {
    Axios.get(getDfInflowUrl + inflowId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getAllDfProcessArchiveDocumentsByInflowId (inflowId, cb) {
    Axios.get(getAllDfProcessArchiveDocumentsByInflowIdUrl + inflowId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getArchiveDocType (cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getArchiveDocTypeUrl).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  insertProcessArchive (form, cb) {
    Axios.post(insertProcessArchiveUrl, form).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  insertProcessArchiveDoc (form, cb) {
    Axios.post(insertProcessArchiveDocUrl, form).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  deleteProcessArchiveDocument (processId, docCode, cb) {
    Axios.post(deleteProcessArchiveDocumentUrl + processId + '&docCode=' + docCode).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  batchFinishProcess (cb, body) {
    Axios.post(baseUrl + 'batchFinishProcess', body).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  BatchPostProcessToEDoc (cb, processIds) {
    let query = '?processIds=' + processIds[0]
    for (let i = 1; i < processIds.length; i++) {
      query += '&processIds=' + processIds[i]
    }
    Axios.post(baseUrl + 'BatchPostProcessToEDoc' + query).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  // For document only
  batchFinishProcessByPrefilled (cb, processIds) {
    let query = '?dfProcessIds=' + processIds[0]
    for (let i = 1; i < processIds.length; i++) {
      query += '&dfProcessIds=' + processIds[i]
    }
    Axios.post(baseUrl + 'batchFinishProcessByPrefilled' + query).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDfDocumentListByInflowId (inflowId, cb) {
    Axios.get(getDfDocumentListByInflowIdUrl + inflowId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDfDocumentListByInflowId2 (inflowId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getDfDocumentListByInflowIdUrl + inflowId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  downloadDocument (cb, docCode, inflowId) {
    console.log('docFlow.js, downloadDocument, docCode : ' + docCode + ', inflowId : ' + inflowId)

    let param = downloadDFDocumentByInflowIdUrl + '?docCode=' + docCode + '&inflowId=' + inflowId
    console.log('param : ' + param)

    Axios.get(param, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response, MIME_TYPES_TO_FILE_EXTENSION[response.data.type])
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getEdocAssignUnit (cb, inflowId) {
    Axios.get(getEdocAssignUnit + inflowId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  downloadInstructionSignedPdf (docCode, processId, cb) {
    let param = downloadInstructionSignedPdfUrl + processId + '&docCode=' + docCode
    Axios.get(param, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  downloadArchiveDocument (docCode, processId, cb) {
    let param = downloadArchiveDocumentUrl + processId + '&docCode=' + docCode
    Axios.get(param, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDfProcessListByInflowIdAndSearchingType (inflowId, searchingType, cb) {
    let param = getDfProcessListByInflowIdAndSearchingTypeUrl + inflowId + '&searchingType=' + searchingType
    console.log('param : ' + param)
    Axios.get(param).then(
      response => {
        // console.log('getDfProcessListByInflowIdAndSearchingType : ' + JSON.stringify(response))
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getSearchAncestorProcess (processId, parentProcessId, inflowStatusCodes, searchingType, cb) {
    let param = getSearchAncestorProcessUrl + inflowStatusCodes + '&processId=' + processId + '&parentProcessId=' + parentProcessId + '&searchingType=' + searchingType
    console.log('param : ' + param)
    Axios.get(param).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDfProcessReceiverInfo (processId, cb) {
    let param = getDfProcessReceiverInfoUrl + processId
    console.log('param : ' + param)
    Axios.get(param).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getSearchProcessLeaf (processId, searchingType, cb) {
    let param = getSearchProcessLeafUrl + processId + '&searchingType=' + searchingType
    console.log('param : ' + param)
    Axios.get(param).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  searchInsertDfProcessArchiveDocument (form, searchingType, cb) {
    let param = searchInsertDfProcessArchiveDocumentUrl + '?searchingType=' + searchingType
    console.log(param + ', form : ' + JSON.stringify(form))
    Axios.post(param, form).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  downloadDfProcessArchiveDocument (docCode, processId, searchingType, cb) {
    console.log('docFlow.js, downloadDocument, docCode : ' + docCode + ', processId : ' + processId + ', searchingType : ' + searchingType)

    let param = downloadDfProcessArchiveDocumentUrl + '?docCode=' + docCode + '&processId=' + processId + '&searchingType=' + searchingType
    console.log('param : ' + param)

    Axios.get(param, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response, MIME_TYPES_TO_FILE_EXTENSION[response.data.type])
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  deleteDfProcessArchiveDocument (processId, docCode, searchingType, cb) {
    Axios.post(deleteDfProcessArchiveDocumentUrl + '?processId=' + processId + '&docCode=' + docCode + '&searchingType=' + searchingType).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getProcessReceiverDetailInfo (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getProcessReceiverDetailInfoUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  revokeProcess (ownProcessId, processId, cb) {
    Axios.post(revokeProcessUrl + processId + '&ownProcessId=' + ownProcessId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  markDeleteSuggestion (cb, processId, remark) {
    Axios.post(baseUrl + 'markDeleteSuggestion?processId=' + processId + '&remark=' + remark).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  downloadDocumentByDocCode (docCode, cb) {
    Axios.get(downloadDocumentByDocCodeUrl + docCode, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getProcessAttachmentCreateInfo (processId, docCode, cb) {
    Axios.get(getProcessAttachmentCreateInfoUrl + processId + '&docCode=' + docCode).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getManageableSubunits (cb) {
    let param = getManageableSubunitsUrl
    console.log('param : ' + param)
    Axios.get(param).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getChildProcessArchiveDoc (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getChildProcessArchiveDocUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  },

  genFlowPdf (processId, inflowStatus, redirectUrl, cb) {
    // let inflowStatusCodes = ''
    // for (let i = 0; i < inflowStatus.length; i++) {
    //   inflowStatusCodes += '&inflowStatusCodes=' + inflowStatus[i]
    // }
    let body = {
      inflowStatusCodes: inflowStatus,
      processId: processId,
      redirectUrl: redirectUrl
    }
    Axios.post(genFlowPdfAndBuildIdLinkUrl, body, { responseType: 'blob' }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  // download as a zipped file
  downloadBatchDocument (processId, docList, cb) {
    let codes = ''
    for (let i = 0; i < docList.length; i++) {
      codes += '&docCodes=' + docList[i].docCode
    }
    Axios.get(downloadBatchDocumentUrl + processId + codes, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDfDocumentOpenerList (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(baseUrl + 'getDfDocumentOpenerList?processId=' + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error.response)
        }
      )
    })
  },

  checkEntityTransferOut (cb) {
    Axios.get(baseUrl + 'checkEntityTransferOut').then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getDFDocumentKey (processId, docCode, cb) {
    let url = baseUrl + 'getDFDocumentKey?processId=' + processId + '&docCode=' + docCode
    return new Promise((resolve, reject) => {
      Axios.get(url).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error.response)
        }
      )
    })
  },

  addDocumentOpener (processId, euidKeyList, cb) {
    let url = baseUrl + 'addDfDocumentOpener?processId=' + processId
    return new Promise((resolve, reject) => {
      Axios.post(url, euidKeyList).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject(error.response)
        }
      )
    })
  },

  getDFDocumentKeyByInflowIdAndSearchingType (docCode, inflowId, openerEuid, searchingType, cb) {
    let param = getDFDocumentKeyUrl + '?docCode=' + docCode + '&inflowId=' + inflowId + '&openerEuid=' + openerEuid + '&searchingType=' + searchingType
    console.log('param : ' + param)
    Axios.get(param).then(
      response => {
        // console.log('getDFDocumentKeyByInflowIdAndSearchingType : ' + JSON.stringify(response))
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  deleteDocumentOpenerKey (inflowId, openerEuid, searchingType, cb) {
    let param = documentOpenerKeyUrl + '?inflowId=' + inflowId + '&openerEuid=' + openerEuid + '&searchingType=' + searchingType
    console.log('param : ' + param)
    Axios.delete(param).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  // getReceiversPublicKey (euids, cb) {
  //   let euidList = ''
  //   for (let i = 0; i < euids.length; i++) {
  //     euidList += '&receiverEuids=' + euids[i]
  //   }
  //   let url = baseUrl + 'getReceiversPublicKey?' + euidList
  //   return new Promise((resolve, reject) => {
  //     Axios.get(url).then(
  //       response => {
  //         cb(response)
  //       },
  //       error => {
  //         cb(error.response)
  //       }
  //     )
  //   })
  // }

  getAllUrgentLevel (cb) {
    Axios.get(baseUrl + 'getAllUrgentLevel').then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getMcProcessReceiverInfo (processId, cb) {
    return new Promise((resolve, reject) => {
      Axios.get(getMcProcessReceiverInfoUrl + processId).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
          reject.error(error.response)
        }
      )
    })
  }

  // getCompletedInflow (pageNo, pageSize, status, keyword, cb) {
  //   let statusCodes = ''
  //   let url = ''
  //   for (let i = 0; i < status.length; i++) {
  //     statusCodes += '&statusCodes=' + status[i]
  //   }
  //   url = getCompletedInflowUrl + pageNo + '&pageSize=' + pageSize + statusCodes
  //   if (keyword) {
  //     url = getCompletedInflowUrl + pageNo + '&pageSize=' + pageSize + statusCodes + '&keyword=' + keyword
  //   }
  //   return new Promise((resolve, reject) => {
  //     Axios.get(url).then(
  //       response => {
  //         cb(response)
  //         resolve()
  //       },
  //       error => {
  //         cb(error.response)
  //         reject.error(error.response)
  //       })
  //   })
  // },

  // getCompletedProcess (inflowId, cb) {
  //   return new Promise((resolve, reject) => {
  //     Axios.get(getCompletedProcessUrl + inflowId).then(
  //       response => {
  //         cb(response)
  //         resolve()
  //       },
  //       error => {
  //         cb(error.response)
  //         reject.error(error.response)
  //       })
  //   })
  // }

}
